import { observer } from "mobx-react-lite";
import React, { useRef, useState } from "react";
import { AnalyticsChartBlockSkeleton } from "../skeletons/AnalyticsChartBlockSkeleton";
import { getChartLoadingMessage } from "./chartLoadingMessage";
import iconScale from "../../../../img/icons/analytics/zoom.png";
import iconScaleActive from "../../../../img/icons/analytics/zoom_active.png";
import stateAnalyticApp from "../../../../state/stateAnalyticApp";
import AnalyticChartData from "../../../../api/AnalyticChartData";
import { formatIsoDateShortDisplay } from "../../../../utils/subscriptionPeriodDate";

const ZOOM_DATE_FIELDS = {
  dates: ["from_date_pr_date", "to_date_pr_date"],
  labelCount: ["from_date_pr_count", "to_date_pr_count"],
  verifyDates: ["from_date_verify_date", "to_date_verify_date"],
  verifyCount: ["from_date_verify_count", "to_date_verify_count"],
};

const CHART_LOADED_STATE = {
  dates: "loaded_printed_dates",
  labelCount: "loaded_printed_count",
  verifyDates: "loaded_verify_dates",
  verifyCount: "loaded_verify_count",
};

export const GraphComponent = observer(
  ({
    children,
    title,
    flag_loaded,
    id,
    setScaleGraph,
    setScaleGraphFlag,
    shiftPress,
  }) => {
    const [imgScale, setImgScale] = useState(iconScale);
    const [scale, setScale] = useState(false);
    const refGraph = useRef();
    const loadedStateKey = CHART_LOADED_STATE[id];
    const isChartLoaded = loadedStateKey
      ? stateAnalyticApp[loadedStateKey]
      : flag_loaded;
    const chartPhase = stateAnalyticApp.chartPhase[id];
    const loadingMessage = getChartLoadingMessage(id, chartPhase);

    const scaleGraph = (e) => {
      setScale((prev) => !prev);
      setScaleGraphFlag(new Date());
      setScaleGraph(e.target.parentNode.parentNode);
    };

    const updateScaleGraph = async (e, from_dt, to_dt) => {
      try {
        let range;
        const from = new Date(stateAnalyticApp[`${from_dt}`]).getTime();
        const to = new Date(stateAnalyticApp[`${to_dt}`]).getTime();
        const period = (to - from) / 1000 / 60 / 60 / 24;
        if (e.deltaY === 100) {
          range = period * 0.8;
        } else if (e.deltaY === -100) {
          range = period * 1.2;
        } else {
          return;
        }
        const rangeDays = (period - range) / 2;
        const rangeFrom =
          new Date(stateAnalyticApp[`${from_dt}`]).getTime() -
          rangeDays * 1000 * 60 * 60 * 24;
        const newFrom = String(new Date(rangeFrom).toISOString().substr(0, 10));
        const rangeTo =
          new Date(stateAnalyticApp[`${to_dt}`]).getTime() +
          rangeDays * 1000 * 60 * 60 * 24;
        const newTo = String(new Date(rangeTo).toISOString().substr(0, 10));
        stateAnalyticApp.setParameter(from_dt, newFrom);
        stateAnalyticApp.setParameter(to_dt, newTo);
        await AnalyticChartData.getPrintedTemplateData(newFrom, newTo, id);
      } catch (err) {
        console.error(err);
      }
    };

    const scalePeriod = (e) => {
      if (
        !shiftPress ||
        !stateAnalyticApp.loaded_printed_dates ||
        !stateAnalyticApp.loaded_printed_count ||
        !stateAnalyticApp.loaded_verify_count
      ) {
        return;
      }
      const dateFields = ZOOM_DATE_FIELDS[refGraph.current?.id];
      if (dateFields) {
        updateScaleGraph(e, dateFields[0], dateFields[1]);
      }
    };

    return (
      <div
        className={
          !scale ? "graph_item_container" : "graph_item_container_active"
        }
        onWheel={scalePeriod}
        ref={refGraph}
        id={id}
      >
        <div className="graph_item_header">
          <h1 className="graph_item_title">{title}</h1>
          <span>
            от {formatIsoDateShortDisplay(stateAnalyticApp.from_date)} до{" "}
            {formatIsoDateShortDisplay(stateAnalyticApp.to_date)}
          </span>
          {!stateAnalyticApp.mobile ? (
            <img
              onClick={scaleGraph}
              className="graph_item_icon_scale"
              onMouseMove={() => setImgScale(iconScaleActive)}
              onMouseOut={() => setImgScale(iconScale)}
              src={imgScale}
              alt=""
            />
          ) : (
            <></>
          )}
        </div>
        {isChartLoaded ? (
          children
        ) : (
          <AnalyticsChartBlockSkeleton chartId={id} message={loadingMessage} />
        )}
      </div>
    );
  },
);
